<template>
  <!--编辑用户-->
  <a-modal :title="title" visible @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  data () {
    return {
      data: {
        status: null
      },
      oriStatus: null,
      options: [
        {
          name: 'status',
          note: '订单状态',
          type: 'Select',
          items: {
            add: '新订订单',
            read: '已读订单',
            madeing: '生产中订单',
            complete: '生产完成订单'
          },
          validators: [
            (val) => val ? null : '不可为空'
          ]
        }
      ]
    }
  },
  mounted () {
    this.data = { status: this.record.status }
    this.oriStatus = this.record.status
  },
  methods: {
    // 发送短信
    // async sendMessage (username) {
    //   // TODO 发送短信消息
    //   this.$tkParse.post('/sms/send', {
    //     'phone': username,
    //     'templateId': 'HqLgB1',
    //     'vars': {
    //       // 短信模板变量
    //       message: `${new Date(this.record.orderDate).getMonth() + 1}月${new Date(this.record.orderDate).getDate()}日下单的${this.record.clientid.name + this.record.finishProductid.name} ${this.record.packid.name + this.record.palletid.name} ${this.options[0].items[this.data.status]}`
    //     }
    //   })
    // },
    async submit () {
      if (this.oriStatus !== this.data.status) {
        let rs = await this.$modelAjax.put('Order', this.record.objectId, this.data).catch(e => {
          this.$notification['error']({
            message: '网络错误，请重新尝试',
            description: '修改订单状态失败'
          })
        })
        if (!this.record.isReserve) { // 备货状态下的订单不发送短信
          // 给销售发短信
          this.$tkParse.post('/sendMessage/sendToOwner', { record: this.record, status: this.options[0].items[this.data.status] })
          // 给内勤发短信
          if (this.data.status === 'complete') {
            this.$tkParse.post('/sendMessage/sendToStaff', { record: this.record, status: this.options[0].items[this.data.status] })
          }
        }
        if (rs) {
          this.$notification['success']({
            message: '操作成功',
            description: '订单状态已修改'
          })
          this.vm.refresh()
        }
      }
      this.$emit('complete', 'cancel')
    },
    cancel () {
      this.$emit('complete', 'cancel')
    },
  },
  props: {
    record: Object, // 当前编辑的整条数据，注意这个数据是实时的，也就是其他字段被修改时，同样能捕捉到
    vm: Object,
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    title: String
  }
}
</script>

<style>

</style>
